import React from 'react';
import { Flex, Text, View, Button } from '@aws-amplify/ui-react';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <View
      width="100%"
      style={{
        backgroundColor: '#2e3a46',
        boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
        marginTop: 'auto'
      }}
    >
      <Flex
        direction="column"
        alignItems="center"
        padding="2rem"
        gap="1rem"
      >
        {/* Legal Links */}
        <Flex
          direction="row"
          justifyContent="center"
          alignItems="center"
          gap="2rem"
          flexWrap="wrap"
        >
          <Button
            onClick={() => navigate('/privacy')}
            variation="link"
            style={{
              color: 'rgba(255,255,255,0.8)',
              fontSize: '0.9rem',
              textDecoration: 'underline',
              padding: '0.5rem',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              transition: 'color 0.3s'
            }}
            onMouseEnter={(e) => {
              e.target.style.color = '#667eea';
            }}
            onMouseLeave={(e) => {
              e.target.style.color = 'rgba(255,255,255,0.8)';
            }}
          >
            Privacy Policy
          </Button>
          
          <Button
            onClick={() => navigate('/terms')}
            variation="link"
            style={{
              color: 'rgba(255,255,255,0.8)',
              fontSize: '0.9rem',
              textDecoration: 'underline',
              padding: '0.5rem',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              transition: 'color 0.3s'
            }}
            onMouseEnter={(e) => {
              e.target.style.color = '#667eea';
            }}
            onMouseLeave={(e) => {
              e.target.style.color = 'rgba(255,255,255,0.8)';
            }}
          >
            Terms of Service
          </Button>
        </Flex>

        {/* Main Footer Content */}
        <Flex
          direction="row"
          justifyContent="center"
          alignItems="center"
          gap="0.5rem"
          flexWrap="wrap"
        >
          <Text 
            color="white" 
            fontSize="1rem"
            fontWeight="500"
            style={{
              letterSpacing: '0.5px'
            }}
          >
            2025 Campus2Career
          </Text>
          <Text 
            color="rgba(255,255,255,0.4)" 
            fontSize="1rem"
            style={{ margin: '0 0.5rem' }}
          >
            •
          </Text>
          <Text 
            color="rgba(255,255,255,0.8)" 
            fontSize="0.95rem"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
          >
            Powered by
            <span style={{
              color: '#ffffff',
              fontWeight: '600'
            }}>
              OpenAI GPT-4o
            </span>
          </Text>
        </Flex>

        {/* Decorative Line */}
        <View
          width="300px"
          height="3px"
          style={{
            background: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
            borderRadius: '2px',
            opacity: 0.8
          }}
        />

        {/* GDPR Notice */}
        <Text
          color="rgba(255,255,255,0.6)"
          fontSize="0.8rem"
          style={{
            textAlign: 'center',
            maxWidth: '600px',
            lineHeight: '1.4'
          }}
        >
          By using this service, you agree to our Terms of Service and Privacy Policy. 
          We use cookies and process personal data in accordance with GDPR.
        </Text>
      </Flex>
    </View>
  );
};

export default Footer;